import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../api/axiosManager';

const BASE = '/api/admin/dashboard/campaigns';

// Genel taslaklar
export const fetchGeneralTemplates = createAsyncThunk(
  'campaignTemplates/fetchGeneral',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`${BASE}/templates`);
      if (response.data?.success && response.data?.data) {
        return response.data.data;
      }
      return [];
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Taslak kampanyalar yüklenemedi');
    }
  }
);

export const fetchGeneralTemplateById = createAsyncThunk(
  'campaignTemplates/fetchGeneralById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.get(`${BASE}/templates/${id}`);
      if (response.data?.success && response.data?.data) {
        return response.data.data;
      }
      return rejectWithValue('Taslak bulunamadı');
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Taslak yüklenemedi');
    }
  }
);

export const createGeneralTemplate = createAsyncThunk(
  'campaignTemplates/createGeneral',
  async (data, { rejectWithValue }) => {
    try {
      const payload = {
        templateName: data.templateName || '',
        campaignImage: data.campaignImage || '',
        campaignImage2: data.campaignImage2 || '',
        campaignImage3: data.campaignImage3 || '',
        campaignTitle: data.campaignTitle || '',
        campaignContent: data.campaignContent || '',
        campaignContentShort: data.campaignContentShort || '',
        campaignFeatures: data.campaignFeatures || '',
        campaignTermsAndConditions: data.campaignTermsAndConditions || '',
      };
      const response = await api.post(`${BASE}/templates`, payload);
      if (response.data?.success && response.data?.data?.NewID) {
        return { id: response.data.data.NewID, ...payload };
      }
      return rejectWithValue('Taslak oluşturulamadı');
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Taslak oluşturulamadı');
    }
  }
);

export const updateGeneralTemplate = createAsyncThunk(
  'campaignTemplates/updateGeneral',
  async ({ id, ...data }, { rejectWithValue }) => {
    try {
      const payload = {
        templateName: data.templateName || '',
        campaignImage: data.campaignImage || '',
        campaignImage2: data.campaignImage2 || '',
        campaignImage3: data.campaignImage3 || '',
        campaignTitle: data.campaignTitle || '',
        campaignContent: data.campaignContent || '',
        campaignContentShort: data.campaignContentShort || '',
        campaignFeatures: data.campaignFeatures || '',
        campaignTermsAndConditions: data.campaignTermsAndConditions || '',
      };
      await api.put(`${BASE}/templates/${id}`, payload);
      return { id, ...payload };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Taslak güncellenemedi');
    }
  }
);

export const deleteGeneralTemplate = createAsyncThunk(
  'campaignTemplates/deleteGeneral',
  async (id, { rejectWithValue }) => {
    try {
      await api.delete(`${BASE}/templates/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Taslak silinemedi');
    }
  }
);

// Bana özel taslaklar
export const fetchPersonalTemplates = createAsyncThunk(
  'campaignTemplates/fetchPersonal',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`${BASE}/personal-templates`);
      if (response.data?.success && response.data?.data) {
        return response.data.data;
      }
      return [];
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Bana özel taslaklar yüklenemedi');
    }
  }
);

export const createPersonalTemplate = createAsyncThunk(
  'campaignTemplates/createPersonal',
  async (data, { rejectWithValue }) => {
    try {
      const payload = {
        templateName: data.templateName || '',
        campaignImage: data.campaignImage || '',
        campaignImage2: data.campaignImage2 || '',
        campaignTitle: data.campaignTitle || '',
        campaignContent: data.campaignContent || '',
        campaignContentShort: data.campaignContentShort || '',
        campaignFeatures: data.campaignFeatures || '',
        campaignTermsAndConditions: data.campaignTermsAndConditions || '',
      };
      const response = await api.post(`${BASE}/personal-templates`, payload);
      if (response.data?.success && response.data?.data?.NewID) {
        return { id: response.data.data.NewID, ...payload };
      }
      return rejectWithValue('Taslak oluşturulamadı');
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Taslak oluşturulamadı');
    }
  }
);

export const updatePersonalTemplate = createAsyncThunk(
  'campaignTemplates/updatePersonal',
  async ({ id, ...data }, { rejectWithValue }) => {
    try {
      const payload = {
        templateName: data.templateName || '',
        campaignImage: data.campaignImage || '',
        campaignImage2: data.campaignImage2 || '',
        campaignTitle: data.campaignTitle || '',
        campaignContent: data.campaignContent || '',
        campaignContentShort: data.campaignContentShort || '',
        campaignFeatures: data.campaignFeatures || '',
        campaignTermsAndConditions: data.campaignTermsAndConditions || '',
      };
      await api.put(`${BASE}/personal-templates/${id}`, payload);
      return { id, ...payload };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Taslak güncellenemedi');
    }
  }
);

export const deletePersonalTemplate = createAsyncThunk(
  'campaignTemplates/deletePersonal',
  async (id, { rejectWithValue }) => {
    try {
      await api.delete(`${BASE}/personal-templates/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Taslak silinemedi');
    }
  }
);

const initialState = {
  generalTemplates: [],
  personalTemplates: [],
  generalLoading: false,
  personalLoading: false,
  generalError: null,
  personalError: null,
  actionLoading: false,
};

const mapApiTemplate = (t) => ({
  id: t.ID || t.id,
  templateName: t.TemplateName || t.templateName || '',
  campaignImage: t.CampaignImage || t.campaignImage || '',
  campaignImage2: t.CampaignImage2 || t.campaignImage2 || '',
  campaignImage3: t.CampaignImage3 || t.campaignImage3 || '',
  campaignTitle: t.CampaignTitle || t.campaignTitle || '',
  campaignContent: t.CampaignContent || t.campaignContent || '',
  campaignContentShort: t.CampaignContentShort || t.campaignContentShort || '',
  campaignFeatures: t.CampaignFeatures || t.campaignFeatures || '',
  campaignTermsAndConditions: t.CampaignTermsAndConditions || t.campaignTermsAndConditions || '',
});

const campaignTemplateSlice = createSlice({
  name: 'campaignTemplates',
  initialState,
  reducers: {
    clearTemplates: (state) => {
      state.generalTemplates = [];
      state.personalTemplates = [];
      state.generalError = null;
      state.personalError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Genel taslaklar
      .addCase(fetchGeneralTemplates.pending, (state) => {
        state.generalLoading = true;
        state.generalError = null;
      })
      .addCase(fetchGeneralTemplates.fulfilled, (state, action) => {
        state.generalLoading = false;
        state.generalTemplates = (action.payload || []).map(mapApiTemplate);
        state.generalError = null;
      })
      .addCase(fetchGeneralTemplates.rejected, (state, action) => {
        state.generalLoading = false;
        state.generalError = action.payload;
      })
      .addCase(createGeneralTemplate.pending, (state) => { state.actionLoading = true; })
      .addCase(createGeneralTemplate.fulfilled, (state, action) => {
        state.actionLoading = false;
        state.generalTemplates.unshift(mapApiTemplate(action.payload));
      })
      .addCase(createGeneralTemplate.rejected, (state) => { state.actionLoading = false; })
      .addCase(updateGeneralTemplate.pending, (state) => { state.actionLoading = true; })
      .addCase(updateGeneralTemplate.fulfilled, (state, action) => {
        state.actionLoading = false;
        const idx = state.generalTemplates.findIndex((t) => Number(t.id) === Number(action.payload.id));
        if (idx !== -1) {
          state.generalTemplates[idx] = mapApiTemplate(action.payload);
        }
      })
      .addCase(updateGeneralTemplate.rejected, (state) => { state.actionLoading = false; })
      .addCase(deleteGeneralTemplate.fulfilled, (state, action) => {
        state.generalTemplates = state.generalTemplates.filter((t) => Number(t.id) !== Number(action.payload));
      })
      // Bana özel taslaklar
      .addCase(fetchPersonalTemplates.pending, (state) => {
        state.personalLoading = true;
        state.personalError = null;
      })
      .addCase(fetchPersonalTemplates.fulfilled, (state, action) => {
        state.personalLoading = false;
        state.personalTemplates = (action.payload || []).map(mapApiTemplate);
        state.personalError = null;
      })
      .addCase(fetchPersonalTemplates.rejected, (state, action) => {
        state.personalLoading = false;
        state.personalError = action.payload;
      })
      .addCase(createPersonalTemplate.pending, (state) => { state.actionLoading = true; })
      .addCase(createPersonalTemplate.fulfilled, (state, action) => {
        state.actionLoading = false;
        state.personalTemplates.unshift(mapApiTemplate(action.payload));
      })
      .addCase(createPersonalTemplate.rejected, (state) => { state.actionLoading = false; })
      .addCase(updatePersonalTemplate.pending, (state) => { state.actionLoading = true; })
      .addCase(updatePersonalTemplate.fulfilled, (state, action) => {
        state.actionLoading = false;
        const idx = state.personalTemplates.findIndex((t) => Number(t.id) === Number(action.payload.id));
        if (idx !== -1) {
          state.personalTemplates[idx] = mapApiTemplate(action.payload);
        }
      })
      .addCase(updatePersonalTemplate.rejected, (state) => { state.actionLoading = false; })
      .addCase(deletePersonalTemplate.fulfilled, (state, action) => {
        state.personalTemplates = state.personalTemplates.filter((t) => Number(t.id) !== Number(action.payload));
      });
  },
});

export const { clearTemplates } = campaignTemplateSlice.actions;
export default campaignTemplateSlice.reducer;
